import React from 'react';
import { messageService } from '../../../Service/message-service';
import styles from '../command-palette.scss';
import { CommandPaletteItem } from './items/CommandPaletteItem';
import { CommandPaletteGhostItems } from './items/CommandPaletteGhostItems';
import { CommandPaletteNoResults } from './items/CommandPaletteNoResults';
import { CommandPaletteError } from './items/CommandPaletteError';
import PropTypes from 'prop-types';
import { usePlugins } from '../hooks/usePlugins';
import { ShowMoreList } from './ShowMoreList';

export const CommandPaletteGroup = ({ search, group, paneId }) => {
  const { groupName, plugins: pluginFns, groupId } = group;

  const groupLabel =
    groupName.type === 'translation'
      ? messageService.get(groupName.key)
      : groupName.value;

  const {
    areLoaded: arePluginsLoaded,
    results: visibleResults,
    isAnyPluginVisible,
    hasError,
  } = usePlugins(paneId, groupId, pluginFns, search);

  return isAnyPluginVisible ? (
    <div
      className={styles.commandPaletteSection}
      role="group"
      aria-label={groupLabel}
    >
      <div className={styles.commandPaletteSectionHeader}>
        <span className={styles.sectionTitle}>{groupLabel}</span>
      </div>
      <div>
        {hasError && <CommandPaletteError />}
        <ShowMoreList
          initialCount={4}
          showMoreText="Show more"
          showLessText="Show less"
          renderToggle={({ text, onToggle }) => (
            <CommandPaletteItem
              id={`${groupName.value}-show-more`}
              label={<span className={styles.showLessLabel}>{text}</span>}
              action={onToggle}
              suppressMetric
            />
          )}
        >
          {visibleResults.map((item, index) => (
            <CommandPaletteItem
              key={`${item.label}-${index}`}
              id={`${groupName.value}-${item.label}-${index}`}
              searchTerm={search}
              {...item}
              category={groupId}
            />
          ))}
        </ShowMoreList>
        {!arePluginsLoaded && <CommandPaletteGhostItems count={4} />}
        {arePluginsLoaded && visibleResults.length === 0 && (
          <CommandPaletteNoResults />
        )}
      </div>
    </div>
  ) : null;
};

CommandPaletteGroup.propTypes = {
  search: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
  paneId: PropTypes.string.isRequired,
};
